import React from "react";
import classNames from "classnames";
import { FilterSourceItem, FilterValues } from "./FilterValuesCollection";

interface ProductListParametersFilterProperties {
    readonly isActive: boolean;
    readonly parameters: FilterSourceItem[];
    readonly filter: FilterValues;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListParametersFilter({
    isActive,
    parameters,
    filter,
    onFilterChange,
    onActivateTab,

}: ProductListParametersFilterProperties): React.JSX.Element | undefined {
    const [activeTab, setActiveTab] = React.useState<number | undefined>(isActive ? parameters[0]?.id : undefined);

    if (parameters.length === 0) {
        return undefined;
    }

    const handleActivateTab = (parameterId: number): void => {
        setActiveTab(parameterId);
        onActivateTab();
    };

    const handleFilterToggle = (parameterId: number, parameterValue: number): void => {
        const currentParameters: Record<number, number[]> = filter.Parameters === undefined
            ? {}
            : Object.assign({}, filter.Parameters);

        if (!(parameterId in currentParameters)) {
            currentParameters[parameterId] = [];
        }

        currentParameters[parameterId] = currentParameters[parameterId].includes(parameterValue)
            ? currentParameters[parameterId].filter((value) => value !== parameterValue)
            : [...currentParameters[parameterId], parameterValue];

        onFilterChange(Object.assign({}, filter, { Parameters: currentParameters }));
    };

    const parameterWidgets = parameters.map((parameter) => <div className="filter-widget" key={parameter.id}>
        <h2
            className={isActive && activeTab === parameter.id ? "active" : undefined}
            onClick={(): void => handleActivateTab(parameter.id)}>{parameter.title}<i className="fa-solid fa-caret-down"></i>
        </h2>

        <div className={classNames("widget-content", { hidden: !isActive || activeTab !== parameter.id })}>
            {parameter.items?.map((parameterItem) => <div className="filter-container" key={parameterItem.value}>
                <label htmlFor={`fr_${parameter.id}_${parameterItem.value}`}>
                    {parameterItem.text}<input
                        type="checkbox" id={`fr_${parameter.id}_${parameterItem.value}`}
                        value={parameterItem.value}
                        checked={filter.Parameters?.[parameter.id]?.includes(parameterItem.value)}
                        onChange={() => handleFilterToggle(parameter.id, parameterItem.value)} />
                    <span className="checkmark"></span>
                </label>
            </div>)}
        </div>
    </div>);

    return <> {parameterWidgets} </>;
}
